import * as rxjs from 'rxjs'

import type { PropertiesConfig } from '../config'
import { Feature } from '../feature'

export class InMemoryStorage<
  // NOTE: this must NOT have any default! If it does, it won't get inferred,
  // which breaks a lot
  const TPropertiesConfig extends PropertiesConfig.Constraint,
> extends Feature<TPropertiesConfig> {
  /**
   * Default name for a {@link InMemoryStorage}. If you have more than one
   * {@link InMemoryStorage} using the same
   * {@link InMemoryStorage.constructor.Params.parent}, you should pass
   * {@link InMemoryStorage.constructor.Params.name} to avoid collisions.
   */
  public static readonly DEFAULT_NAME = 'InMemoryStorage'

  constructor(params: InMemoryStorage.constructor.Params<TPropertiesConfig>) {
    super({
      ...params,
      name: params.name ?? InMemoryStorage.DEFAULT_NAME,
    })
  }

  /**
   * Basically a no-op since there are already reducers on the super class that
   * write the properties to memory
   */
  protected onWriteProperty: Feature<TPropertiesConfig>['onWriteProperty'] =
    () => rxjs.of({ success: true })

  /**
   * Basically a no-op since there are already reducers on the super class that
   * write the properties to memory
   */
  protected onWriteAllProperties: Feature<TPropertiesConfig>['onWriteAllProperties'] =
    () => rxjs.of({ success: true })
}
export namespace InMemoryStorage {
  export namespace constructor {
    export interface Params<
      TPropertiesConfig extends PropertiesConfig.Constraint,
    > extends Partial.Semi<
        Omit<Feature.constructor.Params<TPropertiesConfig>, 'initialValues'>,
        'name'
      > {}
  }
}
